export const CREATE_INSURANCE = 'app/CREATE_INSURANCE';
export const EDIT_INSURANCE = 'app/EDIT_INSURANCE';
export const DELETE_INSURANCE = 'app/DELETE_INSURANCE';

export const CREATE_CONTACT = 'app/CREATE_CONTACT';
export const EDIT_CONTACT = 'app/EDIT_CONTACT';
export const DELETE_CONTACT = 'app/DELETE_CONTACT';
